import { render, staticRenderFns } from "./HistoriaC.vue?vue&type=template&id=58cae76a"
import script from "./HistoriaC.vue?vue&type=script&lang=js"
export * from "./HistoriaC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports